export default "__VITE_ASSET__Bz4CBGNN__"